import { getImageUrl } from "Common/utils/ImageDomain";

interface ImageDataProps {
  imageLink: {
    media_url?: string;
    thumbnail_url?: string;
    image_url?: string;
    profile_url?: string;
  } | null;
  setImageData: React.Dispatch<React.SetStateAction<any>>;
  setImageLink: React.Dispatch<React.SetStateAction<any>>;
}

const ImageData: React.FC<ImageDataProps> = ({
  imageLink,
  setImageData,
  setImageLink,
}) => {
  const imageUrl =
    getImageUrl(
      imageLink?.media_url ||
        imageLink?.thumbnail_url ||
        imageLink?.image_url ||
        imageLink?.profile_url
    ) || "";

  return (
    <div className="relative w-40 h-40">
      {imageUrl ? (
        <img
          data-dz-thumbnail
          className="rounded border-[gray] border"
          style={{
            objectFit: "contain",
            width: "100%",
            height: "100%",
          }}
          src={imageUrl}
          alt="Uploaded image"
        />
      ) : (
        <p>No image available</p>
      )}
      <span
        style={{
          position: "absolute",
          top: "0px",
          right: "6px",
          fontSize: "22px",
          cursor: "pointer",
        }}
        onClick={() => {
          setImageData(null);
          setImageLink(null);
        }}
      >
        ×
      </span>
    </div>
  );
};

export default ImageData;
